/*
 * YourXI custom kit maker (Bespoke XI wizard module)
 *
 * Needs kit-styles/kits.js loaded first (window.YourXIKits).
 * kitmaker.css is injected automatically from the same folder as this script
 * unless a <link> to kitmaker.css is already on the page.
 *
 * const km = YXIKitMaker.mount(containerEl, {
 *   kit,        // outfield kit (kits.js custom kit options), optional
 *   gkKit,      // goalkeeper kit, optional (defaults to a colour that stands out from the outfield kit)
 *   awayKit,    // away kit or null (off)
 *   onChange,   // function (kits, meta) kits = {outfield, gk, away|null}, meta = {gkAuto, tab}
 *   onDark,     // true: preview drawn on the night background
 *   tab         // 'outfield' | 'gk' | 'away', first tab shown
 * });
 * km.update(kits)   // set kits from outside, does not fire onChange
 * km.getKits()      // current kits (copies)
 * km.destroy()
 *
 * A kit is { body, sleeves, collar, cuffs, trim, patternColor, collarStyle, sleeve, pattern, variant, scale }.
 * sleeves null = same as body, cuffs null = same as collar, trim null = no trim (kits.js rules).
 * While the goalkeeper kit is untouched it follows the outfield kit (meta.gkAuto true).
 */
(function (root) {
  'use strict';

  var SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';
  var X = function () {
    if (!root.YourXIKits || !root.YourXIKits.customKitSVG) throw new Error('YXIKitMaker: load kit-styles/kits.js first');
    return root.YourXIKits;
  };

  var KEYS = ['body', 'sleeves', 'collar', 'cuffs', 'trim', 'patternColor', 'collarStyle', 'sleeve', 'pattern', 'variant', 'scale'];
  var COLLARS = [['crew', 'Crew'], ['vneck', 'V-neck'], ['polo', 'Polo'], ['wrap', 'Wrap']];
  var SLEEVES = [['short', 'Short'], ['long', 'Long']];
  var TABS = [['outfield', 'Outfield'], ['gk', 'Goalkeeper'], ['away', 'Away']];
  var TAB_NAME = { outfield: 'Outfield kit', gk: 'Goalkeeper kit', away: 'Away kit' };
  // colour rows. quick: 'link' = null (kits.js default), 'body' / 'collar' = copy that colour
  var ROWS = [
    { f: 'body', label: 'Body', quick: [] },
    { f: 'sleeves', label: 'Sleeves', quick: [['link', 'Same as body']] },
    { f: 'collar', label: 'Collar', quick: [['body', 'Same as body']] },
    { f: 'cuffs', label: 'Cuffs', quick: [['link', 'Same as collar'], ['body', 'Same as body']] },
    { f: 'trim', label: 'Trim', quick: [['link', 'None'], ['collar', 'Same as collar'], ['body', 'Same as body']] }
  ];
  // the two pattern colours, named per pattern: [colour 1 = body, colour 2 = patternColor]
  var PAIR_LABELS = {
    stripes: ['Stripe colour 1', 'Stripe colour 2'], pinstripes: ['Shirt', 'Pinstripes'], hoops: ['Hoop colour 1', 'Hoop colour 2'],
    halves: ['Left', 'Right'], quarters: ['Colour 1', 'Colour 2'], sash: ['Shirt', 'Sash'], chevron: ['Shirt', 'Chevron'],
    gradient: ['Top', 'Bottom'], dots: ['Shirt', 'Dot'], checks: ['Check colour 1', 'Check colour 2'],
    sidePanels: ['Shirt', 'Panels'], shoulderStripes: ['Shirt', 'Stripes']
  };
  function pairLabels(k) {
    if (k.pattern === 'gradient' && k.variant === 'diagonal') return ['Start', 'End'];
    return PAIR_LABELS[k.pattern] || ['Colour 1', 'Colour 2'];
  }
  function colourWord(l) { return /colour/i.test(l) ? l : l + ' colour'; }
  var GK_CANDIDATES = ['#00843D', '#FFD100', '#111111', '#EF6C00', '#5B2C83', '#6CABDD', '#A7A9AC', '#D6006E'];

  /* ---------- helpers ---------- */
  var uidN = 0;
  function uid() { return 'yxk' + (++uidN) + Math.random().toString(36).slice(2, 6); }
  function normHex(h) {
    if (h == null) return null;
    h = String(h).trim().replace(/^#/, '');
    if (/^[0-9a-f]{3}$/i.test(h)) h = h.split('').map(function (c) { return c + c; }).join('');
    return /^[0-9a-f]{6}$/i.test(h) ? '#' + h.toUpperCase() : null;
  }
  function rgb(h) { h = normHex(h) || '#000000'; return [1, 3, 5].map(function (i) { return parseInt(h.slice(i, i + 2), 16); }); }
  function dist(a, b) { var x = rgb(a), y = rgb(b); return Math.hypot(x[0] - y[0], x[1] - y[1], x[2] - y[2]); }
  function lum(h) {
    return rgb(h).map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); })
      .reduce(function (s, v, i) { return s + v * [0.2126, 0.7152, 0.0722][i]; }, 0);
  }
  function inkOn(h) { return lum(h) > 0.4 ? '#111111' : '#FFFFFF'; }
  function same(a, b) { return !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase(); }
  function clone(k) { return k ? JSON.parse(JSON.stringify(k)) : null; }
  function swatches() { return X().KIT_SWATCHES; }
  function colourName(h) {
    if (!h) return '';
    var s = swatches().filter(function (x) { return same(x.hex, h); })[0];
    return s ? s.name : normHex(h);
  }
  function patMeta(id) {
    var P = X().KIT_PATTERNS;
    return P.filter(function (p) { return p.id === id; })[0] || P[0];
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function normalise(o) {
    var D = X().KIT_DEFAULTS, k = {};
    o = o || {};
    KEYS.forEach(function (f) { k[f] = o[f] !== undefined ? o[f] : D[f]; });
    ['body', 'collar', 'patternColor'].forEach(function (f) { k[f] = normHex(k[f]) || normHex(D[f]) || '#FFFFFF'; });
    ['sleeves', 'cuffs', 'trim'].forEach(function (f) { k[f] = normHex(k[f]); });
    if (!COLLARS.some(function (c) { return c[0] === k.collarStyle; })) k.collarStyle = k.collarStyle === 'v' ? 'vneck' : 'crew';
    k.sleeve = k.sleeve === 'long' ? 'long' : 'short';
    var M = patMeta(k.pattern); k.pattern = M.id;
    if (!M.variants || !M.variants.some(function (v) { return v[0] === k.variant; })) k.variant = null;
    k.scale = Math.max(0.5, Math.min(2, +k.scale || 1));
    return k;
  }
  function sameKit(a, b) { return !!a && !!b && KEYS.every(function (f) { return String(a[f]).toLowerCase() === String(b[f]).toLowerCase(); }); }

  function contrastGK(o) {
    var avoid = [o.body, o.sleeves || o.body].concat(o.pattern !== 'plain' ? [o.patternColor] : []);
    var body = GK_CANDIDATES.filter(function (c) { return avoid.every(function (a) { return dist(c, a) > 140; }); })[0] || '#A7A9AC';
    var ink = inkOn(body);
    return normalise({ body: body, sleeves: null, collar: ink, cuffs: null, trim: null, patternColor: ink,
      collarStyle: 'crew', sleeve: 'long', pattern: 'plain', variant: null, scale: 1 });
  }
  function awayFrom(o) {
    var light = lum(o.body) > 0.45;
    var body = light ? (lum(o.collar) < 0.2 ? o.collar : '#14213D') : '#FFFFFF';
    var acc = light ? (lum(o.body) > 0.8 ? '#FFFFFF' : o.body) : o.body;
    if (same(acc, body)) acc = inkOn(body);
    return normalise({ body: body, sleeves: null, collar: acc, cuffs: null, trim: null, patternColor: acc,
      collarStyle: o.collarStyle, sleeve: o.sleeve, pattern: 'plain', variant: null, scale: 1 });
  }
  function describe(k) {
    var M = patMeta(k.pattern), bits = [colourName(k.body) + ' shirt'];
    if (k.sleeves && !same(k.sleeves, k.body)) bits.push(colourName(k.sleeves) + ' sleeves');
    if (M.id !== 'plain') bits.push(colourName(k.patternColor) + ' ' + M.label.toLowerCase());
    bits.push((COLLARS.filter(function (c) { return c[0] === k.collarStyle; })[0] || COLLARS[0])[1] + ' collar in ' + colourName(k.collar).toLowerCase());
    bits.push(k.sleeve === 'long' ? 'long sleeves' : 'short sleeves');
    return bits.join(', ');
  }
  function scaleToSlider(s) { return Math.round(Math.log(s) / Math.LN2 * 100); }
  function sliderToScale(v) { return +Math.pow(2, v / 100).toFixed(3); }

  function ensureCSS() {
    if (document.querySelector('link[href*="kitmaker.css"],style[data-yxk]')) return;
    if (!SCRIPT_SRC) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = SCRIPT_SRC.replace(/kitmaker(\.min)?\.js(\?.*)?$/, 'kitmaker.css');
    document.head.appendChild(l);
  }

  /* ---------- mount ---------- */
  function mount(container, opts) {
    if (!container) throw new Error('YXIKitMaker.mount: container element missing');
    opts = opts || {};
    ensureCSS();

    var id = uid();
    var st = {
      outfield: normalise(opts.kit),
      gk: null, away: opts.awayKit ? normalise(opts.awayKit) : null,
      gkAuto: true,
      tab: TABS.some(function (t) { return t[0] === opts.tab; }) ? opts.tab : 'outfield',
      open: {}, // open colour row per tab (unset: body row open on a plain kit)
      pair: { outfield: 'body', gk: 'body', away: 'body' }, // which pattern colour is being edited
      onDark: !!opts.onDark
    };
    setGK(opts.gkKit);

    var timers = { change: 0, rebuild: 0 }, raf = 0, dead = false;
    var rootEl = document.createElement('div');
    rootEl.className = 'yxk';
    rootEl.innerHTML = '<div class="yxk-layout">' +
      '<div class="yxk-stage">' +
        '<div class="yxk-preview' + (st.onDark ? ' yxk-dark' : '') + '" role="img" data-preview></div>' +
        '<div class="yxk-tabs" role="tablist" aria-label="Kits" data-tabs></div>' +
      '</div>' +
      '<div class="yxk-panel" role="tabpanel" id="' + id + '-panel" tabindex="-1" data-panel></div>' +
      '</div><p class="yxk-sr" aria-live="polite" data-live></p>';
    container.innerHTML = '';
    container.appendChild(rootEl);
    var $ = function (s) { return rootEl.querySelector(s); };

    function setGK(g) {
      var auto = contrastGK(st.outfield);
      st.gk = g ? normalise(g) : auto;
      st.gkAuto = !g || sameKit(st.gk, auto);
    }
    function cur() { return st[st.tab]; }
    function kitsOut() { return { outfield: clone(st.outfield), gk: clone(st.gk), away: clone(st.away) }; }
    function svg(k, extra) {
      var o = Object.assign({}, k, extra || {});
      return X().customKitSVG(o, 'A', o.onDark ? { onDark: true } : null);
    }
    function say(msg) { var l = $('[data-live]'); l.textContent = ''; setTimeout(function () { if (!dead) l.textContent = msg; }, 30); }

    /* ----- change pipeline: mutate state, then live preview (rAF), controls + onChange (now or debounced) ----- */
    function emit() {
      clearTimeout(timers.change);
      if (typeof opts.onChange === 'function') opts.onChange(kitsOut(), { gkAuto: st.gkAuto, tab: st.tab });
    }
    function touched() {
      if (st.tab === 'outfield' && st.gkAuto) st.gk = contrastGK(st.outfield);
      if (st.tab === 'gk') st.gkAuto = false;
    }
    function changed(continuous) {
      touched();
      schedulePreview();
      if (continuous) {
        clearTimeout(timers.change); timers.change = setTimeout(emit, 160);
      } else { rebuild(); emit(); }
    }
    function schedulePreview() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; if (!dead) { drawPreview(); drawLive(); } });
    }

    /* ----- stage: big preview + tabs with mini shirts ----- */
    function drawPreview() {
      var k = cur(), p = $('[data-preview]');
      if (!k) {
        p.innerHTML = '<div class="yxk-ghost">' + svg(st.outfield, { body: '#FFFFFF', sleeves: null, collar: '#FFFFFF', cuffs: null, trim: null, pattern: 'plain' }) + '</div>';
        p.setAttribute('aria-label', 'No away kit yet');
      } else {
        p.innerHTML = svg(k, { onDark: st.onDark });
        p.setAttribute('aria-label', TAB_NAME[st.tab] + ': ' + describe(k));
      }
      p.classList.toggle('yxk-dark', st.onDark);
      drawTabs();
    }
    function drawTabs() {
      var t = $('[data-tabs]'), a = document.activeElement;
      var refocus = a && t.contains(a) ? a.getAttribute('data-k') : null;
      t.innerHTML = TABS.map(function (tb) {
        var on = tb[0] === st.tab, k = st[tb[0]];
        return '<button type="button" role="tab" class="yxk-tab" id="' + id + '-tab-' + tb[0] + '" data-tab="' + tb[0] + '" data-k="tab-' + tb[0] + '"' +
          ' aria-selected="' + on + '" aria-controls="' + id + '-panel" tabindex="' + (on ? 0 : -1) + '">' +
          '<span class="yxk-tab-art" aria-hidden="true">' + (k ? svg(k) : '<span class="yxk-plus">+</span>') + '</span>' +
          '<span class="yxk-tab-l">' + tb[1] + '</span></button>';
      }).join('');
      if (refocus) focusKey(refocus);
      $('[data-panel]').setAttribute('aria-labelledby', id + '-tab-' + st.tab);
    }
    // in-place updates while a colour picker or slider is being dragged (no rebuild, keeps the native picker open)
    function drawLive() {
      var k = cur(); if (!k) return;
      rootEl.querySelectorAll('[data-row-h]').forEach(function (h) {
        var f = h.getAttribute('data-row-h'), v = shown(k, f);
        var dot = h.querySelector('.yxk-dot'), nm = h.querySelector('.yxk-crow-n');
        dot.style.background = v.hex || ''; dot.classList.toggle('yxk-none', !v.hex);
        nm.textContent = v.name;
      });
      rootEl.querySelectorAll('input[data-hex]').forEach(function (inp) {
        var f = inp.getAttribute('data-hex');
        if (document.activeElement !== inp) inp.value = (k[f] || effective(k, f) || '').replace('#', '');
        inp.removeAttribute('aria-invalid');
      });
      rootEl.querySelectorAll('input[data-pick]').forEach(function (inp) {
        var f = inp.getAttribute('data-pick');
        if (document.activeElement !== inp) inp.value = (effective(k, f) || '#FFFFFF').toLowerCase();
      });
    }
    function effective(k, f) {
      if (f === 'sleeves') return k.sleeves || k.body;
      if (f === 'cuffs') return k.cuffs || k.collar;
      return k[f];
    }
    function shown(k, f) {
      if (f === 'sleeves' && !k.sleeves) return { hex: k.body, name: k.pattern === 'plain' ? 'Same as body' : 'Same as colour 1' };
      if (f === 'cuffs' && !k.cuffs) return { hex: k.collar, name: 'Same as collar' };
      if (f === 'trim' && !k.trim) return { hex: null, name: 'None' };
      return { hex: k[f], name: colourName(k[f]) };
    }

    /* ----- controls panel ----- */
    function pairHTML(k) {
      var L = pairLabels(k), act = st.pair[st.tab] === 'patternColor' ? 'patternColor' : 'body', pid = id + '-pair';
      var btn = function (f, i) {
        var on = f === act;
        return '<button type="button" class="yxk-pairbtn" data-pair="' + f + '" data-row-h="' + f + '" data-k="pair-' + f + '" aria-pressed="' + on + '" aria-controls="' + pid + '">' +
          '<span class="yxk-dot" style="background:' + k[f] + '" aria-hidden="true"></span>' +
          '<span class="yxk-pair-t"><span class="yxk-pair-l">' + L[i] + '</span><span class="yxk-crow-n">' + esc(colourName(k[f])) + '</span></span></button>';
      };
      return '<div class="yxk-sub"><div class="yxk-pairhead"><span class="yxk-sublabel" id="' + pid + '-l">Pattern colours</span>' +
        '<button type="button" class="yxk-swap" data-act="swap" data-k="swap"><svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 7h13M12 3l4 4-4 4M17 13H4M8 9l-4 4 4 4"/></svg>Swap colours</button></div>' +
        '<div class="yxk-pair" role="group" aria-labelledby="' + pid + '-l">' + btn('body', 0) + btn('patternColor', 1) + '</div>' +
        '<div class="yxk-pairbody" id="' + pid + '">' + pickerHTML(k, act, colourWord(L[act === 'body' ? 0 : 1]), [], '') + '</div></div>';
    }
    function rowHTML(k, row) {
      var f = row.f, o = st.open[st.tab], isOpen = o === undefined ? (k.pattern === 'plain' && f === 'body') : o === f, v = shown(k, f), bid = id + '-row-' + f;
      var h = '<div class="yxk-crow' + (isOpen ? ' yxk-open' : '') + '">' +
        '<button type="button" class="yxk-crow-h" data-row="' + f + '" data-row-h="' + f + '" data-k="row-' + f + '" aria-expanded="' + isOpen + '" aria-controls="' + bid + '">' +
          '<span class="yxk-crow-l">' + row.label + '</span>' +
          '<span class="yxk-dot' + (v.hex ? '' : ' yxk-none') + '" style="background:' + (v.hex || '') + '" aria-hidden="true"></span>' +
          '<span class="yxk-crow-n">' + esc(v.name) + '</span>' +
          '<span class="yxk-chev" aria-hidden="true"></span></button>';
      if (!isOpen) return h + '</div>';
      return h + '<div class="yxk-crow-b" id="' + bid + '">' + pickerHTML(k, f, row.label + ' colour', row.quick, row.label) + '</div></div>';
    }
    // swatch grid + any colour + hex for one field
    function pickerHTML(k, f, label, quick, short) {
      var h = '', patterned = k.pattern !== 'plain';
      if (quick && quick.length) {
        h += '<div class="yxk-quick" role="group" aria-label="' + short + ' shortcuts">' + quick.map(function (q) {
          var on = q[0] === 'link' ? !k[f] : !!k[f] && same(k[f], k[q[0]]);
          var txt = patterned ? q[1].replace('Same as body', 'Same as colour 1') : q[1];
          return '<button type="button" class="yxk-chip yxk-chip-s" data-quick="' + q[0] + '" data-f="' + f + '" data-k="q-' + f + '-' + q[0] + '" aria-pressed="' + on + '">' + txt + '</button>';
        }).join('') + '</div>';
      }
      var chosen = k[f];
      var anyOn = swatches().some(function (s) { return chosen && same(s.hex, chosen); });
      h += '<div class="yxk-swatches" role="radiogroup" aria-label="' + label + '">' + swatches().map(function (s, i) {
        var on = !!chosen && same(s.hex, chosen);
        return '<button type="button" role="radio" class="yxk-sw' + (lum(s.hex) > 0.8 ? ' yxk-sw-light' : '') + '" style="background:' + s.hex + '" data-sw="' + s.hex + '" data-f="' + f + '" data-k="sw-' + f + '-' + i + '"' +
          ' aria-checked="' + on + '" aria-label="' + s.name + '" title="' + s.name + '" tabindex="' + (on || (!anyOn && i === 0) ? 0 : -1) + '"></button>';
      }).join('') + '</div>';
      var eff = effective(k, f) || '#FFFFFF';
      h += '<div class="yxk-custom">' +
        '<label class="yxk-picker" title="Pick any colour"><input type="color" data-pick="' + f + '" data-k="pick-' + f + '" value="' + eff.toLowerCase() + '" aria-label="Pick any ' + label.toLowerCase() + '"><span aria-hidden="true">Any colour</span></label>' +
        '<label class="yxk-hexwrap"><span class="yxk-hexhash" aria-hidden="true">#</span><input class="yxk-hex" type="text" data-hex="' + f + '" data-k="hex-' + f + '" value="' + ((k[f] || eff).replace('#', '')) + '"' +
          ' maxlength="7" size="7" spellcheck="false" autocomplete="off" autocapitalize="characters" aria-label="' + label + ' as a hex code"></label>' +
        '</div>';
      return h;
    }
    function radios(name, label, items, value, cls) {
      return '<div class="yxk-seg ' + (cls || '') + '" role="radiogroup" aria-label="' + label + '" style="--n:' + items.length + '">' + items.map(function (it, i) {
        var on = it[0] === value;
        return '<button type="button" role="radio" class="yxk-chip" data-' + name + '="' + it[0] + '" data-k="' + name + '-' + it[0] + '" aria-checked="' + on + '" tabindex="' + (on || (!value && i === 0) ? 0 : -1) + '">' + it[1] + '</button>';
      }).join('') + '</div>';
    }
    function rebuild() {
      clearTimeout(timers.rebuild);
      var panel = $('[data-panel]'), k = cur();
      var a = document.activeElement, focusKey = a && rootEl.contains(a) ? a.getAttribute('data-k') : null;
      var h = '';
      if (st.tab === 'away' && !k) {
        h = '<div class="yxk-empty"><p>An away kit is optional. Add one if some players wore your change strip, then pick it for them on the team sheet.</p>' +
          '<button type="button" class="yxk-btn" data-act="add-away" data-k="add-away">Add an away kit</button></div>';
      } else {
        if (st.tab === 'gk') h += '<p class="yxk-note">' + (st.gkAuto ? 'Picked to stand out from your outfield kit. It follows your outfield colours until you change something here.' : 'Your goalkeeper kit. Reset it to go back to a colour that stands out from the outfield kit.') + '</p>';
        // pattern
        var M = patMeta(k.pattern);
        h += '<section class="yxk-sec"><h3 class="yxk-h" id="' + id + '-pat">Pattern</h3>' +
          '<div class="yxk-pats" role="radiogroup" aria-labelledby="' + id + '-pat">' + X().KIT_PATTERNS.map(function (p) {
            var on = p.id === k.pattern;
            var pc = same(k.patternColor, k.body) ? inkOn(k.body) : k.patternColor;
            return '<button type="button" role="radio" class="yxk-pat" data-pat="' + p.id + '" data-k="pat-' + p.id + '" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '">' +
              '<span class="yxk-pat-art" aria-hidden="true">' + svg(k, { pattern: p.id, variant: null, scale: 1, patternColor: pc }) + '</span><span class="yxk-pat-l">' + p.label + '</span></button>';
          }).join('') + '</div>';
        if (M.id !== 'plain') {
          h += pairHTML(k);
          if (M.variants) h += '<div class="yxk-sub"><span class="yxk-sublabel" id="' + id + '-var">Style</span>' + radios('variant', M.label + ' style', M.variants, k.variant || M.variant, 'yxk-wrap') + '</div>';
          if (M.scale) {
            var sv = scaleToSlider(k.scale);
            h += '<div class="yxk-sub"><label class="yxk-sublabel" for="' + id + '-scale">Size</label><div class="yxk-range"><span aria-hidden="true">Finer</span>' +
              '<input type="range" id="' + id + '-scale" data-scale data-k="scale" min="-100" max="100" step="5" value="' + sv + '" aria-valuetext="' + scaleText(k.scale) + '"><span aria-hidden="true">Bolder</span></div></div>';
          }
        }
        h += '</section>';
        // colours: with a pattern, body is colour 1 above, so only sleeves, collar, cuffs and trim here
        var patterned = M.id !== 'plain';
        h += '<section class="yxk-sec"><h3 class="yxk-h">' + (patterned ? 'Sleeves, collar and trim' : 'Colours') + '</h3><div class="yxk-rows">' +
          ROWS.filter(function (r) { return !(patterned && r.f === 'body'); }).map(function (r) { return rowHTML(k, r); }).join('') + '</div></section>';
        // collar + sleeves
        h += '<section class="yxk-sec"><h3 class="yxk-h">Collar</h3>' + radios('collar', 'Collar style', COLLARS, k.collarStyle) + '</section>';
        h += '<section class="yxk-sec"><h3 class="yxk-h">Sleeves</h3>' + radios('sleeve', 'Sleeve length', SLEEVES, k.sleeve) + '</section>';
        h += '<div class="yxk-actions"><button type="button" class="yxk-btn yxk-btn-2" data-act="reset" data-k="reset">Reset this kit</button>' +
          (st.tab === 'away' ? '<button type="button" class="yxk-btn yxk-btn-2" data-act="remove-away" data-k="remove-away">Remove away kit</button>' : '') + '</div>';
      }
      panel.innerHTML = h;
      if (focusKey) {
        var el = rootEl.querySelector('[data-k="' + focusKey + '"]');
        if (el) el.focus({ preventScroll: true });
      }
    }
    function scaleText(s) { return s === 1 ? 'Standard size' : (s < 1 ? 'Finer, ' : 'Bolder, ') + Math.round(s * 100) + ' percent'; }

    /* ----- actions ----- */
    function setColour(f, hex, continuous) {
      var k = cur(); if (!k) return;
      k[f] = hex;
      changed(continuous);
    }
    function onClick(e) {
      var b = e.target.closest('button'); if (!b || !rootEl.contains(b)) return;
      var k = cur(), d = b.dataset;
      if (d.tab) { if (d.tab !== st.tab) { st.tab = d.tab; drawPreview(); rebuild(); } return; }
      if (d.act === 'add-away') { st.away = awayFrom(st.outfield); delete st.open.away; drawPreview(); rebuild(); emit(); say('Away kit added'); focusKey('row-body'); return; }
      if (d.act === 'remove-away') { st.away = null; drawPreview(); rebuild(); emit(); say('Away kit removed'); focusKey('add-away'); return; }
      if (d.act === 'reset') {
        if (st.tab === 'outfield') { st.outfield = normalise(null); if (st.gkAuto) st.gk = contrastGK(st.outfield); }
        else if (st.tab === 'gk') { st.gk = contrastGK(st.outfield); st.gkAuto = true; }
        else st.away = awayFrom(st.outfield);
        schedulePreview(); rebuild(); emit(); say(TAB_NAME[st.tab] + ' reset'); return;
      }
      if (!k) return;
      if (d.act === 'swap') { var t = k.body; k.body = k.patternColor; k.patternColor = t; changed(false); say('Colours swapped'); return; }
      if (d.pair) { st.pair[st.tab] = d.pair; rebuild(); return; }
      if (d.row) { st.open[st.tab] = d.row === (st.open[st.tab] === undefined && k.pattern === 'plain' ? 'body' : st.open[st.tab]) ? null : d.row; rebuild(); return; }
      if (d.sw) { setColour(d.f, d.sw); return; }
      if (d.quick) {
        var f = d.f, q = d.quick;
        k[f] = q === 'link' ? null : k[q];   // 'body' or 'collar': copy that colour
        changed(false); return;
      }
      if (d.pat) {
        if (d.pat === k.pattern) return;
        if (d.pat === 'plain' && !st.open[st.tab]) st.open[st.tab] = 'body';
        if (d.pat !== 'plain' && st.open[st.tab] === 'body') st.open[st.tab] = null;
        k.pattern = d.pat; k.variant = null;
        if (d.pat !== 'plain' && same(k.patternColor, k.body)) k.patternColor = same(k.collar, k.body) ? inkOn(k.body) : k.collar;
        changed(false); return;
      }
      if (d.variant) { k.variant = d.variant === patMeta(k.pattern).variant ? null : d.variant; changed(false); return; }
      if (d.collar) { k.collarStyle = d.collar; changed(false); return; }
      if (d.sleeve) { k.sleeve = d.sleeve; changed(false); return; }
    }
    function focusKey(key) { var el = rootEl.querySelector('[data-k="' + key + '"]'); if (el) el.focus({ preventScroll: true }); }
    function onInput(e) {
      var t = e.target, k = cur(); if (!k) return;
      if (t.hasAttribute('data-pick')) { setColour(t.getAttribute('data-pick'), normHex(t.value), true); return; }
      if (t.hasAttribute('data-hex')) {
        var h = normHex(t.value);
        if (h && t.value.replace('#', '').length === 6) { t.removeAttribute('aria-invalid'); setColour(t.getAttribute('data-hex'), h, true); }
        return;
      }
      if (t.hasAttribute('data-scale')) {
        k.scale = sliderToScale(+t.value); t.setAttribute('aria-valuetext', scaleText(k.scale));
        changed(true);
      }
    }
    function onChangeEvt(e) {
      var t = e.target, k = cur(); if (!k) return;
      if (t.hasAttribute('data-pick') || t.hasAttribute('data-scale')) { emit(); timers.rebuild = setTimeout(rebuild, 0); return; }
      if (t.hasAttribute('data-hex')) commitHex(t);
    }
    function commitHex(t) {
      var h = normHex(t.value), f = t.getAttribute('data-hex'), k = cur();
      if (!h) { t.setAttribute('aria-invalid', 'true'); say('That is not a colour code. Use six characters, like C8102E.'); return; }
      t.removeAttribute('aria-invalid');
      k[f] = h; touched(); schedulePreview(); emit(); rebuild();
    }

    /* ----- keyboard: tabs and radio groups move with arrow keys ----- */
    function onKey(e) {
      var t = e.target;
      if (t.matches && t.matches('input[data-hex]') && e.key === 'Enter') { e.preventDefault(); commitHex(t); return; }
      var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (keys.indexOf(e.key) < 0) return;
      var role = t.getAttribute && t.getAttribute('role');
      if (role !== 'tab' && role !== 'radio') return;
      var group = t.parentElement, items = Array.prototype.slice.call(group.children).filter(function (x) { return x.getAttribute('role') === role; });
      var i = items.indexOf(t), n = items.length, j = i;
      var cols = 1;
      if (role === 'radio') { var top = items[0].offsetTop; cols = items.filter(function (x) { return x.offsetTop === top; }).length || 1; }
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'ArrowDown') j = role === 'tab' ? (i + 1) % n : Math.min(n - 1, i + cols);
      else if (e.key === 'ArrowUp') j = role === 'tab' ? (i - 1 + n) % n : Math.max(0, i - cols);
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      e.preventDefault();
      if (j === i) return;
      var key = items[j].getAttribute('data-k');
      items[j].click();           // selection follows focus
      focusKey(key);
    }

    rootEl.addEventListener('click', onClick);
    rootEl.addEventListener('input', onInput);
    rootEl.addEventListener('change', onChangeEvt);
    rootEl.addEventListener('keydown', onKey);
    drawPreview(); rebuild();

    return {
      update: function (kits) {
        if (dead || !kits) return;
        if (kits.outfield) st.outfield = normalise(kits.outfield);
        if ('away' in kits) st.away = kits.away ? normalise(kits.away) : null;
        if (kits.gk) setGK(kits.gk);
        else if (st.gkAuto) st.gk = contrastGK(st.outfield);
        if (typeof kits.gkAuto === 'boolean') { st.gkAuto = kits.gkAuto; if (st.gkAuto) st.gk = contrastGK(st.outfield); }
        drawPreview(); rebuild();
      },
      getKits: kitsOut,
      destroy: function () {
        dead = true;
        clearTimeout(timers.change); clearTimeout(timers.rebuild); cancelAnimationFrame(raf);
        rootEl.removeEventListener('click', onClick);
        rootEl.removeEventListener('input', onInput);
        rootEl.removeEventListener('change', onChangeEvt);
        rootEl.removeEventListener('keydown', onKey);
        if (rootEl.parentNode) rootEl.parentNode.removeChild(rootEl);
      }
    };
  }

  root.YXIKitMaker = { mount: mount, contrastGK: function (k) { return contrastGK(normalise(k)); }, awayFrom: function (k) { return awayFrom(normalise(k)); }, normalise: normalise, describe: function (k) { return describe(normalise(k)); } };
})(window);
